import React, { Component } from 'react';
//import UserDetailsService from '..services/UserDetailsService';
import { Container, Row, Col, Button } from 'react-bootstrap';
import Auth from '../services/Auth';


interface IHeaderProps {
    title?: string,
    header?: string

}

interface IHeaderState {
   fullName: string
}

class Header extends Component<IHeaderProps, IHeaderState> {
    constructor(props: IHeaderProps) {
        super(props);
        
        this.state = { 
            fullName: ''
        };
    }

    onLogout = (event: any) => {
        Auth.logout();
    }
    
    async componentDidMount() {
        //let userInfo = await UserDetailsService.loadUserDetails();
        this.setState({
            //userInfo
        });
    }
    
    render() {
        const loggedInLabel = 'Обучающийся ' + this.state.fullName;
        return (  
                <div className='main-header'>
                    <Container>
                        <Row>
                            <Col md={4}>
                                <div className='panel-logo'></div>
                                <h2 className="q-main-tabs-title">{this.props.title}</h2>
                            </Col>
                            <Col md={4} className='case-group'>{this.props.header}</Col>
                            <Col md={4} className="q-main-tabs-logged-in-container">
                                {
                                    this.state.fullName ?
                                        <span className="text-right q-main-tabs-logged-in-label">{loggedInLabel}</span>
                                    : null 
                                }
                                <Button className="pull-right" onClick={this.onLogout}>
                                    {/*<i.Glyphicon glyph="off" />*/} Выйти
                                </Button>
                            </Col>
                        </Row>
                    </Container>
                </div>);
    }
}
 
export default Header;